/* BAD NAILZ: canonical shade previews, one-click drop playback, PL/EN UI. */
(() => {
 'use strict';
 if (window.__BN_MEDIA_FIX_20260915__) return;
 window.__BN_MEDIA_FIX_20260915__ = true;
 const rows = `001 5a77e320d10f4ff597b754ae75da4683 93592790 3.0
002 de33cce377c649f2a3a6d6ba6276067f 93592977 4.5
100 3f8014eebcd34bfebfeff56ea10b56b0 93592978 3.0
101 62f93de0d6a34e66b61626060bb57faa 93592979 3.0
102 b53e0f0ae5044f71a08b350b21dd5bda 93592980 4.5
103 cb0527c1681346748e16f97db79a6f0a 93592997 4.5
104 2bc01a7508a34aa7a128a1c0e4a47900 93592998 4.5
105 6e5aced60d6a4ff78af6a23a6c6061ab 93593000 4.5
106 04e32e5446c84b6d9e9142db9c13efd7 93593001 3.0
107 c5c7b6cfb1c64ff4ba6dad15a72f4980 93593002 4.5
108 251cddeb2b344aa8bbf55464b702710b 93592959 4.5
109 7dd46a9079124aae88a883f70c8d9657 93593030 4.5
110 d5488ab96e514e5c8dd46fe5ebb66902 94112461 4.5
128 c5a56a12807445efa816104c8a69c49f 93593088 3.0
129 9809417e8a034d4e98ca98fdaf8d2883 93593089 4.5
130 ee025cc9a844447b8768a783a35b3688 93593124 4.5
132 b9e222985d354fb2b4253dd15ed37caf 93593125 4.5
133 0bc1653f800f45bfb2bc7afb19705ab2 93593126 3.0
134 72d00c5c3b96480081a8983d2e73207a 93593127 3.0
135 11093162855d4cf881854cd5bc8377f0 93593128 3.0
300 8d5328ecd49d4e2eb62f36cd55637072 93593159 4.5
301 6468ce701c4d441ca3ddbea21250f849 93593160 3.0
302 5fa8775b612642dfbdc818537cf00d81 93593161 4.5
303 b64d892ec62a447ea2417a7bf6196a40 93593162 4.5
304 1984ce1ca0a945dd8022f3cc9790810c 93593163 3.0
305 da5aaa0fb4434eee8453101581259b52 93593201 4.5
306 085b012f52334ab8af34b115b73f609b 93593202 4.5
307 000c4e9c2dbc487a88a3ad0c41e7b2fc 93593203 3.0
500 4d100eb1a69a436f9081be7c717d0751 93593204 4.5
501 661235a9cd1f4992be635bdcc36ba175 93593205 4.5
502 3bf2e3fa50f4423f8a3023635c59ca2b 94112463 4.5
503 09bbade5db0a4bb8aa36dc1c8447bc1b 94112464 4.5
504 07e9d04462ce4955a45ad64b8e25fb6e 94112467 4.5
505 97d11079bac644e1a524fe9198f4ba02 94112470 4.5
506 fe5089bc85614b349c461566ce9dbaf3 94112473 4.5
507 e0ab1ad4af864694b69c17b909cdb45f 94112476 3.0
508 af07ee74b8614ba39c5bb30e7fa0c0c9 94112479 4.5
509 3812df3bd4734283ab2a930ea3a210d7 94112482 4.5
510 66b6ed6946ac40a992998f411d7c206e 94112484 3.0
702 63bf81bbdc5944a0b3ce8e9d25d8202e 93593224 3.0
706 d0c88283435548ac87d8c9d23321de1d 93593225 4.5
707 4584765860564c30b81e990a82302bdd 93593226 4.5
709 e8e36773416a496d82610cbaa0bc08ea 93593227 4.5
710 f6304cabd2a1479abe10c4825404d146 93593228 4.5
711 16f0a442a53b42a789c32a59a96de0ff 93593229 4.5`;
 const sources = Object.fromEntries(rows.split('\n').map(row => {
  const [code,hash,suffix,rate] = row.split(' ');
  return [code, `https://cdn.shopify.com/videos/c/vp/${hash}/${hash}.HD-720p-${rate}Mbps-${suffix}.mp4`];
 }));
 try { Object.assign(sources, JSON.parse(document.getElementById('bn-brush-sources')?.textContent || '{}')); } catch (error) { console.warn('BAD NAILZ media configuration could not be read.'); }
 window.BN_MEDIA_REGISTRY = sources;
 const isEN = /^en(?:-|$)/i.test(document.documentElement.lang || window.Shopify?.locale || 'pl');
 const text = (pl,en) => isEN ? en : pl;
 const cardSelector = '.bn-color-card,[data-bn-color-card],[data-color-card],.q-card,.bnv2-product,.bn-drop-card';
 const states = new WeakMap();
 const audit = {};
 window.__BN_PROOF_AUDIT__ = audit;
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const autoAllowed = () => !reduced.matches && !navigator.connection?.saveData;
 const shadeCode = card => {
  for (const a of card.querySelectorAll('a[href*="/products/"]')) {
   const found = a.getAttribute('href').match(/\/products\/(\d{3})(?:[-/?#]|$)/);
   if (found) return found[1];
  }
  const n = String(card.dataset.number || '');
  if (/^\d{3}$/.test(n)) return n;
  const title = card.querySelector('.bn-drop-card__title,.q-name,.bnv2-product__name,h3,h2');
  return title?.textContent.trim().match(/^(\d{3})\b/)?.[1] || null;
 };
 const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
 let homeAutoPaused = false;
 let nextVideoId = 0;
 const liveStates = new Set();
 const sync = st => {
  const playing = Boolean(st.v && !st.v.paused && st.v.readyState >= 2);
  st.card.classList.toggle('bn-proof-playing',playing);
  st.media.classList.toggle('bn-proof-playing',playing);
  if(st.control){
   st.control.setAttribute('aria-pressed',String(playing));
   st.control.setAttribute('aria-label',text(playing?'Zatrzymaj wideo koloru ':'Odtwórz wideo koloru ',playing?'Pause shade video ':'Play shade video ')+st.code);
   st.control.querySelector('[data-video-icon]').innerHTML=playing?'<path d="M6 4h4v16H6zm8 0h4v16h-4z"/>':'<path d="m7 4 13 8-13 8z"/>';
   st.control.querySelector('[data-video-label]').textContent=playing?text('Pauza','Pause'):text('Wideo','Video');
  }
  if(st.drop){
   st.media.setAttribute('aria-pressed',String(playing));
   st.media.setAttribute('aria-label',text(playing?'Zatrzymaj kolor ':'Odtwórz kolor ',playing?'Pause shade ':'Play shade ')+st.code);
  }
 };
 const clearVideo = v => {
  v.pause();v.removeAttribute('autoplay');v.removeAttribute('src');
  v.querySelectorAll('source').forEach(s=>s.remove());v.load();
 };
 const stop = st => {
  st.wanted=false;st.v?.pause();
  st.card.classList.remove('is-playing','is-video-hover');
  st.media.classList.remove('is-playing','is-video-playing');
  sync(st);
 };
 const start = (st, explicit=false) => {
  if(!st.v || !st.url || (!explicit && (!autoAllowed() || st.userPaused)) || document.hidden)return;
  liveStates.forEach(other=>{if(other!==st)stop(other)});
  document.querySelectorAll('video').forEach(v=>{if(v!==st.v && !v.paused)v.pause()});
  st.wanted=true;
  if(!st.v.getAttribute('src'))st.v.src=st.url;
  st.v.play().then(()=>{if(!st.wanted){st.v.pause();return}sync(st)}).catch(()=>stop(st));
 };
 const toggle = st => {
  if(st.wanted || !st.v.paused){st.userPaused=true;if(st.home)homeAutoPaused=true;stop(st)}
  else{st.userPaused=false;start(st,true)}
 };
 const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
   const st=states.get(entry.target);if(!st)return;
   st.visible=entry.isIntersecting && entry.intersectionRatio>=.6;
   if(!entry.isIntersecting)stop(st);
  });
  if(homeAutoPaused || !autoAllowed() || document.hidden)return;
  if([...document.querySelectorAll('video')].some(v=>!v.paused))return;
  const candidate=[...liveStates].find(st=>st.home && st.visible && !st.userPaused);
  if(candidate)start(candidate);
 },{threshold:[0,.6]}) : null;
 const addControl = st => {
  const card=st.card;
  let row=card.querySelector('.bn-mod-card__meta,.bn-color-wow-card__meta,.bn-color-card__top,.q-top');
  if(!row){
   const body=card.querySelector('.bnca__body,.bn-drop-card__body,.bnv2-product__body,.bn-color-card__body');
   if(!body)return;
   row=document.createElement('div');row.className='bn-video-row';body.prepend(row);
  }
  if(card.matches('[data-bn-color-card],[data-color-card]')){
   [...row.children].forEach(child=>{if(/^\d{3}$/.test(child.textContent.trim()))child.remove()});
  }
  const button=document.createElement('button');button.type='button';button.className='bn-card-video-toggle';
  button.innerHTML='<svg data-video-icon viewBox="0 0 24 24" aria-hidden="true" focusable="false"></svg><span data-video-label></span>';
  st.v.id ||= 'bn-shade-video-'+(++nextVideoId);
  button.setAttribute('aria-controls',st.v.id);
  button.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();toggle(st)});
  row.classList.add('bn-video-control-row');row.appendChild(button);st.control=button;sync(st);
 };
 const prepare = card => {
  const code=shadeCode(card);if(!code)return;
  const media=card.querySelector('.bnv2-product__media,.bn-color-card__media,.bn-mod-card__media,.q-media,.bn-drop-card__media') || card.querySelector('img')?.closest('a,button');
  if(!media || (states.has(media) && states.get(media).code===code))return;
  const drop=card.classList.contains('bn-drop-card');
  const url=sources[code] || '';
  const all=[...media.querySelectorAll('video')];let v=all.shift() || null;
  const videoPoster=v?.poster || '';
  all.forEach(other=>{clearVideo(other);other.remove()});
  media.querySelectorAll('img.bnv2-product__secondary').forEach(img=>img.remove());
  card.querySelectorAll('.bnx-video-trigger').forEach(button=>button.remove());
  if(v)clearVideo(v);
  if(code==='714'){
   let photo=media.querySelector('img');if(!photo){photo=document.createElement('img');media.prepend(photo)}
   photo.src='https://cdn.shopify.com/s/files/1/0927/5159/3806/files/714_ddc9e2f9-02aa-44a4-b5ed-894de133e189.webp?v=1786627951';photo.removeAttribute('srcset');photo.alt='714 HOT MISTAKE';photo.loading='lazy';
  }
  if(drop && !media.querySelector('img') && videoPoster){
   const photo=document.createElement('img');photo.src=videoPoster;photo.alt=card.querySelector('.bn-drop-card__title')?.textContent.trim() || code;photo.loading='lazy';photo.width=900;photo.height=900;media.prepend(photo);
  }
  media.classList.add('bn-proof-media');media.dataset.bnVideoMedia='true';
  const st={card,media,code,url,v:null,drop,home:card.matches('[data-bn-quick-clean] .q-card'),wanted:false,userPaused:false,visible:false,control:null};states.set(media,st);
  card.dataset.bnProofCode=code;
  audit[code]={source:url,status:url?'DEDICATED_SWATCH_FILE':'NO_DEDICATED_SWATCH_FILE'};
  if(!url){
   if(v)v.remove();media.classList.add('bn-proof-static');
   const body=card.querySelector('.bnca__body,.bn-drop-card__body');
   if(body){const spacer=document.createElement('div');spacer.className='bn-video-row';spacer.setAttribute('aria-hidden','true');body.prepend(spacer)}
   media.querySelectorAll('.bn-drop-card__play,.bn-drop-video-control,.bn-color-card__motion,.bn-mod-card__motion,.q-motion,.q-badge,.bnv2-product__video-label,.bn-mod-card__badge,.bn-color-wow-card__video-label').forEach(n=>n.remove());
   if(drop){media.disabled=false;media.setAttribute('aria-label',text('Zobacz kolor ','View shade ')+code);media.removeAttribute('aria-pressed')}
   return;
  }
  if(!v){v=document.createElement('video');media.appendChild(v)}
  st.v=v;v.classList.add('bn-proof-video');v.preload='none';v.muted=true;v.defaultMuted=true;v.loop=true;v.playsInline=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.setAttribute('aria-hidden','true');v.removeAttribute('data-bnv2-autoplay');
  const image=media.querySelector('img:not(.bnv2-product__secondary)');if(image)v.poster=image.currentSrc||image.src;
  media.querySelectorAll('.bn-drop-video-control').forEach(n=>n.remove());
  if(drop){
   media.disabled=false;
   if(!media.querySelector('.bn-drop-card__play')){const icon=document.createElement('span');icon.className='bn-drop-card__play';icon.setAttribute('aria-hidden','true');icon.textContent='▶';media.appendChild(icon)}
  }
  addControl(st);liveStates.add(st);visibility?.observe(media);
  card.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse' && finePointer.matches)start(st)});
  card.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse' && finePointer.matches)stop(st)});
  v.addEventListener('error',()=>stop(st));
  v.addEventListener('play',()=>{if(!st.wanted)stop(st)});
  v.addEventListener('playing',()=>sync(st));
  v.addEventListener('pause',()=>{st.wanted=false;sync(st)});
 };
 document.addEventListener('click',e=>{
  const media=e.target.closest?.('.bn-drop-card__media.bn-proof-media');const st=media&&states.get(media);
  if(!st?.url)return;e.preventDefault();e.stopImmediatePropagation();toggle(st);
 },true);
 document.addEventListener('keydown',e=>{
  if(e.repeat||!['Enter',' '].includes(e.key))return;
  const media=e.target.closest?.('.bn-drop-card__media.bn-proof-media');const st=media&&states.get(media);
  if(!st?.url)return;e.preventDefault();e.stopImmediatePropagation();toggle(st);
 },true);
 reduced.addEventListener?.('change',()=>{if(reduced.matches)liveStates.forEach(stop)});
 const labels={
 'DO KOSZYKA':'ADD TO CART','DODAJ DO KOSZYKA':'ADD TO CART','DODAJĘ':'ADDING','DODANO':'ADDED','NIEDOSTĘPNE':'UNAVAILABLE','NIEDOSTĘPNY':'UNAVAILABLE','WYPRZEDANE':'SOLD OUT',
 'WYBIERAM TEN':'CHOOSE THIS SHADE','NAJEDŹ: WIDEO':'HOVER: VIDEO','NAJEDŹ:WIDEO':'HOVER: VIDEO','ZOBACZ KOLORY':'SHOP SHADES','Zobacz kolory':'Shop shades','Wybierz kolor':'Choose your shade','WYBIERZ SWÓJ KOLOR':'CHOOSE YOUR SHADE','Wybierz zestaw':'Choose your kit',
 'KOLORY':'SHADES','BAZY I TOPY':'BASES & TOPS','BAZY + TOPY':'BASES + TOPS','PREP / BŁYSK / MAT':'PREP / GLOSS / MATTE','PREP + BŁYSK':'PREP + GLOSS','PREP + BŁYSK + MAT':'PREP + GLOSS + MATTE','ZESTAWY':'KITS','DODATKI':'EXTRAS','NOWOŚCI / DROPY':'NEW DROPS','NOWOŚCI':'NEW IN','ZACZNIJ':'GET STARTED','KONTAKT':'CONTACT',
 'LAKIER HYBRYDOWY':'GEL POLISH','KLASYCZNE':'CLASSIC','PASTELE':'PASTELS','NEONY':'NEONS','BROKATY':'GLITTERS','RÓŻE':'PINKS','FIOLETY':'PURPLES','CZERWIENIE / BORDO':'REDS / BURGUNDY','NUDE / BEŻE':'NUDES / BEIGES','NIEBIESKIE / ZIELENIE':'BLUES / GREENS','BIEL / SZAROŚĆ / CZERŃ':'WHITE / GREY / BLACK',
 'WSZYSTKIE':'ALL','WSZYSTKIE KOLORY':'ALL SHADES','FILTRUJ':'FILTER','FILTRY':'FILTERS','WYCZYŚĆ':'CLEAR','Wyczyść filtry':'Clear filters','Wyczyść wszystko':'Clear all','Szukaj koloru':'Search shades','Szukaj koloru lub numeru':'Search by shade or number','Numer rosnąco':'Shade number: low to high','Numer malejąco':'Shade number: high to low','Cena rosnąco':'Price: low to high','Cena malejąco':'Price: high to low','Domyślnie':'Default','Sortuj':'Sort',
 'KOSZYK':'CART','Koszyk':'Cart','PRZEJDŹ DO PŁATNOŚCI':'CHECK OUT','Przejdź do płatności':'Check out','KONTYNUUJ ZAKUPY':'CONTINUE SHOPPING','Kontynuuj zakupy':'Continue shopping','Twój koszyk jest pusty':'Your cart is empty','Twój koszyk jest pusty.':'Your cart is empty.','SUMA':'TOTAL','Suma':'Total','Razem':'Total','Usuń':'Remove','Zamknij':'Close','Dostawa obliczona przy kasie':'Shipping calculated at checkout',
 'RUN OUT / JESIENNA PALETA':'RUN OUT / AUTUMN PALETTE','RUN OUT. KOLORY NA JESIEŃ.':'RUN OUT. AUTUMN SHADES.','Trzy odcienie bordo, ciemny brąz, butelkowa zieleń i głęboki fiolet. Wybierz swój kolor albo dodaj całą szóstkę.':'Three burgundy shades, dark brown, bottle green and deep purple. Pick a shade or add all six.','DODAJ 6 KOLORÓW':'ADD ALL 6 SHADES','6 KOLORÓW / 1 FLOW':'6 SHADES / 1 FLOW','WYBIERZ SWÓJ DROP':'CHOOSE YOUR DROP','ZOBACZ DROP':'EXPLORE THE DROP','DOSTĘPNE TERAZ':'AVAILABLE NOW','NAJNOWSZY DROP':'LATEST DROP',
 'NAPISZ DO NASDANE KONTAKTOWE':'GET IN TOUCH','NAPISZ DO NAS':'GET IN TOUCH','DANE KONTAKTOWE':'CONTACT DETAILS','Imię':'Name','Twój e-mail':'Your email','Adres e-mail':'Email address','Telefon':'Phone','Temat':'Subject','Wiadomość':'Message','Wyślij':'Send','WYŚLIJ':'SEND','Pytanie o produkt':'Product question','Moje zamówienie':'My order','Współpraca':'Collaboration','Inne':'Other',
 'DARMOWA DOSTAWA OD 150 ZŁ':'FREE SHIPPING FROM PLN 150','Darmowa dostawa od 150 zł':'Free shipping from PLN 150','Dostawa 18 zł. Darmowa od 150 zł.':'Shipping PLN 18. Free from PLN 150.','Wysyłka tylko na terenie Polski.':'Shipping within Poland only.',
 'O NAS':'ABOUT US','POLITYKA PRYWATNOŚCI':'PRIVACY POLICY','REGULAMIN':'TERMS & CONDITIONS','DOSTAWA I PŁATNOŚCI':'SHIPPING & PAYMENTS','ZWROTY I REKLAMACJE':'RETURNS & COMPLAINTS','ZAPISZ SIĘ':'SIGN UP','Zapisz się':'Sign up','BĄDŹ NA BIEŻĄCO':'STAY IN THE LOOP','ODBIERZ POWIADOMIENIE':'NOTIFY ME','POKAŻ SWÓJ LOOK':'SHARE YOUR LOOK',
 'PRZEJDŹ DO ZACZNIJ →':'GET STARTED →','ZACZNIJ TUTAJ':'START HERE','MAM LAMPĘ':'I HAVE A LAMP','ZACZYNAM OD ZERA':'STARTING FROM SCRATCH','ZOBACZ ZESTAWY':'EXPLORE KITS','PRZYGOTOWANIE':'PREP','BAZA + KOLOR':'BASE + COLOUR','TOP + FINISH':'TOP + FINISH','Zobacz cały proces':'Watch the full process','ZOBACZ CAŁY PROCES':'WATCH THE FULL PROCESS','SZCZEGÓŁY':'DETAILS','Jak używać':'How to use','Skład':'Ingredients','Dodaj do ulubionych':'Add to wishlist','Usuń z ulubionych':'Remove from wishlist'
 };
 const fixes={'e-mial':'e-mail','E-mial':'E-mail','Zamoknij':'Zamknij','zamoknij':'zamknij','Misto':'Miasto','Pytenie':'Pytanie','NAPISZ DO NASDANE KONTAKTOWE':'NAPISZ DO NAS'};
 const normal=s=>s.replace(/\s+/g,' ').trim();
 const convert=s=>{const n=normal(s);const translated=isEN?(labels[n]||labels[fixes[n]]):fixes[n];return translated?s.replace(s.trim(),translated):s};
 const localize = scope => {
  const walk=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT,{acceptNode:n=>n.parentElement?.closest('script,style,textarea,code,pre,template,[data-cart-acceptance-label]')?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT});
  let n;while((n=walk.nextNode())){const t=convert(n.nodeValue);if(t!==n.nodeValue)n.nodeValue=t}
  scope.querySelectorAll?.('[placeholder],[aria-label],[title],input[type="submit"]').forEach(el=>{
   ['placeholder','aria-label','title'].forEach(k=>{const v=el.getAttribute(k);if(v){const t=convert(v);if(t!==v)el.setAttribute(k,t)}});
   if(el.matches('input[type="submit"]')){const v=convert(el.value);if(v!==el.value)el.value=v}
  });
  if(isEN)scope.querySelectorAll?.('a[href]').forEach(a=>{
   if(a.hasAttribute('hreflang')||a.closest('[data-localization-form],[data-locale-selector],.localization-form'))return;
   const h=a.getAttribute('href');if(h==='/' || /^\/(?:products|collections|pages|cart|search)(?:[/?#]|$)/.test(h))a.setAttribute('href','/en'+h);
  });
 };
 const boot = () => {
  if(!document.body)return;
  if(!document.getElementById('bn-proof-media-style')){
   const style=document.createElement('style');style.id='bn-proof-media-style';
   style.textContent='.bn-proof-media{position:relative!important;overflow:hidden}.bn-proof-media img:not(.bnv2-product__secondary){opacity:1!important;visibility:visible!important}.bn-proof-media .bn-proof-video{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;display:block!important;opacity:0!important;pointer-events:none!important}.bn-proof-media.bn-proof-playing .bn-proof-video{opacity:1!important}.bn-proof-media.bn-proof-playing img{opacity:0!important}.bn-proof-static .bn-drop-card__play,.bn-proof-static .bn-drop-video-control{display:none!important}.bn-proof-static{cursor:default!important}.bn-proof-static:disabled{opacity:1!important}.bn-proof-playing .bn-drop-card__play{opacity:0!important;pointer-events:none!important}@media(hover:none){.bn-proof-media .bn-color-card__motion,.bn-proof-media .q-motion{display:none!important}}';document.head.appendChild(style);
  }
  document.querySelectorAll(cardSelector).forEach(prepare);localize(document.body);
 };
 let frame=0;const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;boot()})};
 const observer=new MutationObserver(schedule);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{boot();observer.observe(document.body,{subtree:true,childList:true,characterData:true})},{once:true});else{boot();observer.observe(document.body,{subtree:true,childList:true,characterData:true})}
 document.addEventListener('shopify:section:load',schedule);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('.bn-proof-media').forEach(m=>{const st=states.get(m);if(st)stop(st)})});
})();
